<template>
    <div class="admin-pricing-container">
        <el-card class="box-card">
            <template #header>
                <div class="card-header">
                    <span>价格与促销管理</span>
                </div>
            </template>

            <el-tabs v-model="activeTab">
                <!-- 1. 试卷价格管理 -->
                <el-tab-pane label="试卷价格管理" name="papers">
                    <div class="filter-bar">
                        <el-input v-model="filter.keyword" placeholder="搜索试卷名称" style="width: 200px" clearable
                            @keyup.enter="fetchPapers" />
                        <el-select v-model="filter.category" placeholder="分类" clearable
                            style="width: 150px; margin-left: 10px">
                            <el-option label="同步卷" value="同步卷" />
                            <el-option label="月考卷" value="月考卷" />
                            <el-option label="期中卷" value="期中卷" />
                            <el-option label="期末卷" value="期末卷" />
                            <el-option label="模拟卷" value="模拟卷" />
                            <el-option label="真题卷" value="真题卷" />
                            <el-option label="强基计划" value="强基计划" />
                            <el-option label="讲义课件" value="讲义课件" />
                        </el-select>
                        <el-button type="primary" style="margin-left: 10px" @click="fetchPapers">查询</el-button>
                    </div>

                    <el-table :data="paperList" style="width: 100%; margin-top: 20px" v-loading="loadingPapers">
                        <el-table-column prop="id" label="ID" width="80" />
                        <el-table-column prop="name" label="试卷名称" min-width="200" show-overflow-tooltip />
                        <el-table-column prop="category" label="分类" width="120" />
                        <el-table-column label="当前价格" width="180">
                            <template #default="scope">
                                <div v-if="scope.row.isFree">
                                    <el-tag type="success">免费</el-tag>
                                </div>
                                <div v-else-if="scope.row.customPrice > 0">
                                    <span class="price-text">{{ (scope.row.customPrice / 100).toFixed(2) }} 元</span>
                                    <el-tag type="warning" size="small" style="margin-left:5px">覆盖</el-tag>
                                </div>
                                <div v-else>
                                    <span class="price-text">{{ (getDefaultPrice(scope.row.category) / 100).toFixed(2)
                                    }} 元</span>
                                    <el-tag type="info" size="small" style="margin-left:5px">默认</el-tag>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="150">
                            <template #default="scope">
                                <el-button type="primary" size="small"
                                    @click="editPaperPrice(scope.row)">精确定价</el-button>
                            </template>
                        </el-table-column>
                    </el-table>

                    <div class="pagination-container">
                        <el-pagination v-model:currentPage="page" v-model:pageSize="pageSize" :page-sizes="[10, 20, 50]"
                            layout="total, sizes, prev, pager, next" :total="totalPapers" @size-change="fetchPapers"
                            @current-change="fetchPapers" />
                    </div>
                </el-tab-pane>

                <!-- 2. 组卷阶梯定价 -->
                <el-tab-pane label="组卷阶梯定价" name="tiers">
                    <div class="action-bar-v">
                        <div class="action-row">
                            <el-button type="success" @click="showAddTier">新增阶梯</el-button>
                            <el-alert title="优先级说明" type="warning"
                                description="此处配置的阶梯价将覆盖 config.yaml 中的默认硬编码配置。请确保阶梯范围不重叠。" :closable="false" show-icon
                                style="flex: 1; margin-left: 20px;" />
                        </div>

                        <div class="defaults-info">
                            <span class="label">系统默认参考 (config.yaml):</span>
                            <div class="tags-group">
                                <el-tag size="small" type="info" effect="plain">0-10题: 免费</el-tag>
                                <el-tag size="small" type="info" effect="plain">11-20题: 0.5元</el-tag>
                                <el-tag size="small" type="info" effect="plain">21-40题: 1.0元</el-tag>
                                <el-tag size="small" type="info" effect="plain">41-60题: 1.5元</el-tag>
                                <el-tag size="small" type="info" effect="plain">61题以上: 2.0元</el-tag>
                            </div>
                        </div>
                    </div>

                    <el-table :data="tierList" style="width: 100%; margin-top: 20px" border>
                        <el-table-column label="题目数量范围">
                            <template #default="scope">
                                {{ scope.row.min_questions }} - {{ scope.row.max_questions === 9999 ? '以上' :
                                    scope.row.max_questions }} 题
                            </template>
                        </el-table-column>
                        <el-table-column label="价格 (元)">
                            <template #default="scope">
                                {{ (scope.row.price / 100).toFixed(2) }} 元
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="180">
                            <template #default="scope">
                                <el-button type="primary" size="small" @click="editTier(scope.row)">编辑</el-button>
                                <el-button type="danger" size="small" @click="deleteTier(scope.row.ID)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>

                <!-- 3. 促销活动管理 -->
                <el-tab-pane label="促销活动管理" name="promotions">
                    <!-- ... existing promotion table ... -->
                </el-tab-pane>

                <!-- 4. 下载免费 & 积分设置 -->
                <el-tab-pane label="下载免费设置" name="download_free">
                    <div class="download-free-panel">
                        <el-alert
                            title="说明：开启后在配置时间段内将跳过下载付费校验。时间留空表示长期免费（直到手动关闭）。"
                            type="info"
                            :closable="false"
                            show-icon
                        />

                        <el-card shadow="never" class="free-item-card">
                            <template #header>
                                <div class="free-item-header">
                                    <span>积分抵扣比例设置</span>
                                    <el-tag type="primary" size="small">下载时积分最大抵扣比例</el-tag>
                                </div>
                            </template>
                            <el-form label-width="150px">
                                <el-form-item label="积分最大抵扣比例">
                                    <el-slider
                                        v-model="pointsSettings.maxOffsetPercentage"
                                        :min="0"
                                        :max="100"
                                        :step="5"
                                        show-input
                                        style="width: 400px"
                                    />
                                </el-form-item>
                                <el-form-item>
                                    <el-text type="info" size="small">
                                        设为 100% 时，积分足够可免费下载；不足时补差价。设为 0 则禁用积分抵扣。
                                    </el-text>
                                </el-form-item>
                            </el-form>
                            <div style="display:flex; justify-content:flex-end; margin-top:10px">
                                <el-button type="primary" :loading="savingPointsSettings" @click="savePointsSettings">
                                    保存积分设置
                                </el-button>
                            </div>
                        </el-card>

                        <el-card shadow="never" class="free-item-card">
                            <template #header>
                                <div class="free-item-header">
                                    <span>组卷下载（/zujuan）</span>
                                    <el-tag :type="downloadFreeSettings.custom_paper.is_active_now ? 'success' : 'info'" size="small">
                                        {{ downloadFreeSettings.custom_paper.is_active_now ? '当前生效' : '当前未生效' }}
                                    </el-tag>
                                </div>
                            </template>
                            <el-form label-width="130px">
                                <el-form-item label="启用免费">
                                    <el-switch v-model="downloadFreeSettings.custom_paper.is_enabled" />
                                </el-form-item>
                                <el-form-item label="免费时间范围">
                                    <el-date-picker
                                        v-model="downloadFreeSettings.custom_paper.timeRange"
                                        type="datetimerange"
                                        range-separator="至"
                                        start-placeholder="开始时间"
                                        end-placeholder="结束时间"
                                        value-format="x"
                                        clearable
                                    />
                                </el-form-item>
                            </el-form>
                        </el-card>

                        <el-card shadow="never" class="free-item-card">
                            <template #header>
                                <div class="free-item-header">
                                    <span>试卷下载（/paper）</span>
                                    <el-tag :type="downloadFreeSettings.paper.is_active_now ? 'success' : 'info'" size="small">
                                        {{ downloadFreeSettings.paper.is_active_now ? '当前生效' : '当前未生效' }}
                                    </el-tag>
                                </div>
                            </template>
                            <el-form label-width="130px">
                                <el-form-item label="启用免费">
                                    <el-switch v-model="downloadFreeSettings.paper.is_enabled" />
                                </el-form-item>
                                <el-form-item label="免费时间范围">
                                    <el-date-picker
                                        v-model="downloadFreeSettings.paper.timeRange"
                                        type="datetimerange"
                                        range-separator="至"
                                        start-placeholder="开始时间"
                                        end-placeholder="结束时间"
                                        value-format="x"
                                        clearable
                                    />
                                </el-form-item>
                            </el-form>
                        </el-card>

                        <div class="download-free-actions">
                            <el-button type="primary" :loading="savingDownloadFreeSettings" @click="saveDownloadFreeSettings">
                                保存下载免费设置
                            </el-button>
                        </div>
                    </div>
                </el-tab-pane>

                <!-- 5. 用户积分管理 -->
                <el-tab-pane label="用户积分管理" name="user_points">
                    <div class="user-search-bar">
                        <el-autocomplete v-model="userSearchQuery" :fetch-suggestions="queryUsers" placeholder="输入用户名或ID搜索用户"
                            value-key="username" @select="handleUserSelect" style="width: 300px">
                            <template #default="{ item }">
                                <div class="user-item">
                                    <span class="user-id">#{{ item.id }}</span>
                                    <span class="user-name">{{ item.username }}</span>
                                </div>
                            </template>
                        </el-autocomplete>
                    </div>

                    <el-table v-if="selectedUser" :data="[selectedUser]" style="width: 100%; margin-top: 20px" border>
                        <el-table-column prop="id" label="ID" width="80" />
                        <el-table-column prop="username" label="用户名" />
                        <el-table-column prop="total_points" label="当前积分" width="120">
                            <template #default="scope">
                                <span style="font-weight: bold; color: #e6a23c;">{{ scope.row.total_points }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="role" label="角色" width="100" />
                        <el-table-column label="操作">
                            <template #default="scope">
                                <el-button type="primary" size="small" @click="showAwardDialog(scope.row)">调整积分</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
            </el-tabs>
        </el-card>

        <!-- Award Points Dialog -->
        <el-dialog v-model="awardDialog.visible" title="用户积分调整" width="400px">
            <el-form label-width="80px">
                <el-form-item label="用户">
                    <el-tag>{{ awardDialog.username }} (ID: {{ awardDialog.userId }})</el-tag>
                </el-form-item>
                <el-form-item label="变动数量">
                    <el-input-number v-model="awardDialog.delta" :min="-10000" :max="10000" placeholder="正数为增加，负数为扣除" />
                    <div class="form-helper">正数增加积分，负数扣除积分</div>
                </el-form-item>
                <el-form-item label="原因备注">
                    <el-input v-model="awardDialog.remark" placeholder="如：活动赠送、系统补偿" />
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button @click="awardDialog.visible = false">取消</el-button>
                <el-button type="primary" @click="confirmAwardPoints" :loading="awardDialog.loading">提交</el-button>
            </template>
        </el-dialog>

        <!-- Paper Price Dialog -->
        <el-dialog v-model="paperDialog.visible" title="试卷精确定价" width="400px">
            <el-form label-width="100px">
                <el-form-item label="试卷名称">
                    <div class="info-text">{{ paperDialog.data.name }}</div>
                </el-form-item>
                <el-form-item label="设置为免费">
                    <el-switch v-model="paperDialog.data.isFree" />
                </el-form-item>
                <el-form-item label="自定义价格" v-if="!paperDialog.data.isFree">
                    <el-input-number v-model="paperDialog.priceYuan" :precision="2" :step="0.1" :min="0" />
                    <span style="margin-left: 10px">元</span>
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button @click="paperDialog.visible = false">取消</el-button>
                <el-button type="primary" @click="savePaperPrice">保存</el-button>
            </template>
        </el-dialog>

        <!-- Tier Dialog -->
        <el-dialog v-model="tierDialog.visible" :title="tierDialog.data.ID ? '编辑阶梯' : '新增阶梯'" width="450px">
            <el-form label-width="120px">
                <el-form-item label="最小题目数">
                    <el-input-number v-model="tierDialog.data.min_questions" :min="0" />
                </el-form-item>
                <el-form-item label="最大题目数">
                    <el-input-number v-model="tierDialog.data.max_questions" :min="1" />
                    <span class="tip-text" style="display:block">输入 9999 代表“以上”</span>
                </el-form-item>
                <el-form-item label="价格 (元)">
                    <el-input-number v-model="tierDialog.priceYuan" :precision="2" :step="0.5" :min="0" />
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button @click="tierDialog.visible = false">取消</el-button>
                <el-button type="primary" @click="saveTier">提交</el-button>
            </template>
        </el-dialog>

        <!-- Promotion Dialog -->
        <el-dialog v-model="promoDialog.visible" :title="promoDialog.data.ID ? '编辑活动' : '创建活动'" width="550px">
            <el-form label-width="100px">
                <el-form-item label="活动名称">
                    <el-input v-model="promoDialog.data.name" placeholder="例如：春季开学特惠" />
                </el-form-item>
                <el-form-item label="活动描述">
                    <el-input type="textarea" v-model="promoDialog.data.description" />
                </el-form-item>
                <el-form-item label="优惠范围">
                    <el-radio-group v-model="promoDialog.data.target_type">
                        <el-radio label="all">全站资源</el-radio>
                        <el-radio label="category">指定分类</el-radio>
                        <el-radio label="paper">指定试卷</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="分类名称" v-if="promoDialog.data.target_type === 'category'">
                    <el-select v-model="promoDialog.data.target_value" placeholder="选择分类">
                        <el-option v-for="c in categories" :key="c" :label="c" :value="c" />
                    </el-select>
                </el-form-item>
                <el-form-item label="试卷ID" v-if="promoDialog.data.target_type === 'paper'">
                    <el-input-number v-model="promoDialog.data.target_id" :min="1" />
                </el-form-item>
                <el-form-item label="优惠方案">
                    <el-radio-group v-model="promoDialog.data.discount_type">
                        <el-radio label="fixed">固定减免(分)</el-radio>
                        <el-radio label="percent">打折(%)</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item :label="promoDialog.data.discount_type === 'fixed' ? '减免金额' : '折扣值'">
                    <el-input-number v-model="promoDialog.data.discount_val"
                        v-if="promoDialog.data.discount_type === 'percent'" :min="1" :max="100" />
                    <div v-else>
                        <el-input-number v-model="promoDialog.priceYuan" :precision="2" :min="0" /> <span
                            style="margin-left:5px">元</span>
                    </div>
                    <span v-if="promoDialog.data.discount_type === 'percent'" style="margin-left:10px">例如：80 代表 8
                        折</span>
                </el-form-item>
                <el-form-item label="活动时间">
                    <el-date-picker v-model="promoDialog.timeRange" type="datetimerange" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期" value-format="x" />
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button @click="promoDialog.visible = false">取消</el-button>
                <el-button type="primary" @click="savePromotion">发布活动</el-button>
            </template>
        </el-dialog>
    </div>
</template>

<script setup>
import { ref, onMounted, reactive } from 'vue'
import api from '@/utils/api'
import { ElMessage, ElMessageBox } from 'element-plus'

const activeTab = ref('papers')
const loadingPapers = ref(false)
const savingDownloadFreeSettings = ref(false)

// User Points Management
const userSearchQuery = ref('')
const selectedUser = ref(null)
const awardDialog = reactive({
    visible: false,
    loading: false,
    userId: null,
    username: '',
    delta: 10,
    remark: ''
})

const queryUsers = async (queryString, cb) => {
    if (!queryString) {
        cb([])
        return
    }
    try {
        const res = await api.get('/api/admin/users/search', { params: { query: queryString } })
        cb(res.data.users || [])
    } catch (error) {
        console.error('Search users error:', error)
        cb([])
    }
}

const handleUserSelect = (item) => {
    selectedUser.value = item
}

const showAwardDialog = (user) => {
    awardDialog.userId = user.id
    awardDialog.username = user.username
    awardDialog.delta = 10
    awardDialog.remark = ''
    awardDialog.visible = true
}

const confirmAwardPoints = async () => {
    if (!awardDialog.userId || awardDialog.delta === 0) return

    awardDialog.loading = true
    try {
        await api.post('/api/admin/users/award-points', {
            user_id: awardDialog.userId,
            delta: awardDialog.delta,
            remark: awardDialog.remark
        })
        
        // Update local points balance
        if (selectedUser.value && selectedUser.value.id === awardDialog.userId) {
            selectedUser.value.total_points += awardDialog.delta
        }

        ElMessage.success('积分调整成功')
        awardDialog.visible = false
    } catch (error) {
        ElMessage.error(error.message || '调整失败')
    } finally {
        awardDialog.loading = false
    }
}
const paperList = ref([])
const totalPapers = ref(0)
const page = ref(1)
const pageSize = ref(10)
const filter = reactive({
    keyword: '',
    category: ''
})

const tierList = ref([])
const promotionList = ref([])
const categories = ['同步卷', '月考卷', '期中卷', '期末卷', '模拟卷', '真题卷', '强基计划', '讲义课件']
const downloadFreeSettings = reactive({
    paper: {
        is_enabled: false,
        start_time: 0,
        end_time: 0,
        is_active_now: false,
        timeRange: []
    },
    custom_paper: {
        is_enabled: false,
        start_time: 0,
        end_time: 0,
        is_active_now: false,
        timeRange: []
    }
})

// Config defaults (Mirror backend config.yaml)
const defaultPrices = {
    "同步卷": 100,
    "月考卷": 200,
    "期中卷": 200,
    "期末卷": 200,
    "模拟卷": 300,
    "真题卷": 300,
    "强基计划": 300,
    "讲义课件": 200
}

const getDefaultPrice = (cat) => defaultPrices[cat] || 0

// Dialog States
const paperDialog = reactive({
    visible: false,
    priceYuan: 0,
    data: {}
})

const tierDialog = reactive({
    visible: false,
    priceYuan: 0,
    data: {}
})

const promoDialog = reactive({
    visible: false,
    priceYuan: 0,
    timeRange: [],
    data: {
        target_type: 'all',
        discount_type: 'percent',
        discount_val: 100
    }
})

onMounted(() => {
    fetchPapers()
    fetchTiers()
    fetchPromotions()
    fetchDownloadFreeSettings()
    fetchPointsSettings()
})

// --- Papers ---
const fetchPapers = async () => {
    loadingPapers.value = true
    try {
        const res = await api.get('/api/admin/paper-prices', {
            params: {
                page: page.value,
                pageSize: pageSize.value,
                keyword: filter.keyword,
                category: filter.category
            }
        })
        paperList.value = res.data.list
        totalPapers.value = res.data.total
    } finally {
        loadingPapers.value = false
    }
}

const editPaperPrice = (paper) => {
    paperDialog.data = { ...paper }
    paperDialog.priceYuan = paper.customPrice / 100
    paperDialog.visible = true
}

const savePaperPrice = async () => {
    try {
        await api.post('/api/admin/paper-prices/update', {
            id: paperDialog.data.id,
            customPrice: Math.round(paperDialog.priceYuan * 100),
            isFree: paperDialog.data.isFree
        })
        ElMessage.success('保存成功')
        paperDialog.visible = false
        fetchPapers()
    } catch (err) {
        ElMessage.error('保存失败')
    }
}

// --- Tiers ---
const fetchTiers = async () => {
    const res = await api.get('/api/admin/pricing-tiers')
    tierList.value = res.data
}

const showAddTier = () => {
    tierDialog.data = { min_questions: 1, max_questions: 20, price: 0 }
    tierDialog.priceYuan = 0
    tierDialog.visible = true
}

const editTier = (tier) => {
    tierDialog.data = { ...tier }
    tierDialog.priceYuan = tier.price / 100
    tierDialog.visible = true
}

const saveTier = async () => {
    try {
        const payload = {
            ...tierDialog.data,
            price: Math.round(tierDialog.priceYuan * 100)
        }
        await api.post('/api/admin/pricing-tiers', payload)
        ElMessage.success('保存成功')
        tierDialog.visible = false
        fetchTiers()
    } catch (err) {
        ElMessage.error('保存失败')
    }
}

const deleteTier = (id) => {
    ElMessageBox.confirm('确定删除此价格阶梯吗？', '提示', { type: 'warning' }).then(async () => {
        await api.delete(`/api/admin/pricing-tiers/${id}`)
        ElMessage.success('删除成功')
        fetchTiers()
    })
}

// --- Promotions ---
const fetchPromotions = async () => {
    const res = await api.get('/api/admin/promotions')
    promotionList.value = res.data
}

const showAddPromotion = () => {
    promoDialog.data = {
        name: '',
        description: '',
        target_type: 'all',
        discount_type: 'percent',
        discount_val: 100,
        is_active: true
    }
    promoDialog.priceYuan = 0
    promoDialog.timeRange = [Date.now(), Date.now() + 7 * 86400000]
    promoDialog.visible = true
}

const editPromotion = (promo) => {
    promoDialog.data = { ...promo }
    promoDialog.priceYuan = promo.discount_val / 100
    promoDialog.timeRange = [promo.start_time * 1000, promo.end_time * 1000]
    promoDialog.visible = true
}

const savePromotion = async () => {
    try {
        const payload = { ...promoDialog.data }
        if (payload.discount_type === 'fixed') {
            payload.discount_val = Math.round(promoDialog.priceYuan * 100)
        }
        payload.start_time = Math.round(promoDialog.timeRange[0] / 1000)
        payload.end_time = Math.round(promoDialog.timeRange[1] / 1000)

        if (payload.ID) {
            await api.put('/api/admin/promotions', payload)
        } else {
            await api.post('/api/admin/promotions', payload)
        }
        ElMessage.success('发布成功')
        promoDialog.visible = false
        fetchPromotions()
    } catch (err) {
        ElMessage.error('发布失败')
    }
}

const togglePromotion = async (promo) => {
    try {
        await api.put('/api/admin/promotions', promo)
        ElMessage.success(promo.is_active ? '活动已启用' : '活动已禁用')
    } catch (err) {
        promo.is_active = !promo.is_active
        ElMessage.error('操作失败')
    }
}

const deletePromotion = (id) => {
    ElMessageBox.confirm('确定删除此促销活动吗？', '提示', { type: 'warning' }).then(async () => {
        await api.delete(`/api/admin/promotions/${id}`)
        ElMessage.success('删除成功')
        fetchPromotions()
    })
}

// --- Download Free Settings ---

// --- Points Settings ---
const pointsSettings = reactive({ maxOffsetPercentage: 100 })
const savingPointsSettings = ref(false)

const fetchPointsSettings = async () => {
    try {
        const res = await api.get('/api/admin/points-settings')
        pointsSettings.maxOffsetPercentage = res.data.max_offset_percentage ?? 100
    } catch (e) {
        console.error('获取积分设置失败', e)
    }
}

const savePointsSettings = async () => {
    savingPointsSettings.value = true
    try {
        await api.post('/api/admin/points-settings', {
            max_offset_percentage: pointsSettings.maxOffsetPercentage
        })
        ElMessage.success('积分设置已保存')
    } catch (e) {
        ElMessage.error(e?.response?.data?.error || '保存失败')
    } finally {
        savingPointsSettings.value = false
    }
}

const applyDownloadFreeSettings = (data) => {
    const applySingle = (target, source) => {
        target.is_enabled = !!source?.is_enabled
        target.start_time = Number(source?.start_time || 0)
        target.end_time = Number(source?.end_time || 0)
        target.is_active_now = !!source?.is_active_now
        if (target.start_time > 0 && target.end_time > 0) {
            target.timeRange = [target.start_time * 1000, target.end_time * 1000]
        } else {
            target.timeRange = []
        }
    }

    applySingle(downloadFreeSettings.paper, data?.paper)
    applySingle(downloadFreeSettings.custom_paper, data?.custom_paper)
}

const fetchDownloadFreeSettings = async () => {
    try {
        const res = await api.get('/api/admin/download-free-settings')
        applyDownloadFreeSettings(res.data)
    } catch (error) {
        ElMessage.error('获取下载免费设置失败')
    }
}

const syncTimeRangeToUnix = (target) => {
    if (!target.timeRange || target.timeRange.length !== 2) {
        target.start_time = 0
        target.end_time = 0
        return
    }
    target.start_time = Math.floor(Number(target.timeRange[0]) / 1000)
    target.end_time = Math.floor(Number(target.timeRange[1]) / 1000)
}

const saveDownloadFreeSettings = async () => {
    syncTimeRangeToUnix(downloadFreeSettings.paper)
    syncTimeRangeToUnix(downloadFreeSettings.custom_paper)

    if (
        downloadFreeSettings.paper.start_time > 0 &&
        downloadFreeSettings.paper.end_time > 0 &&
        downloadFreeSettings.paper.start_time > downloadFreeSettings.paper.end_time
    ) {
        ElMessage.error('试卷下载免费时间范围无效')
        return
    }

    if (
        downloadFreeSettings.custom_paper.start_time > 0 &&
        downloadFreeSettings.custom_paper.end_time > 0 &&
        downloadFreeSettings.custom_paper.start_time > downloadFreeSettings.custom_paper.end_time
    ) {
        ElMessage.error('组卷下载免费时间范围无效')
        return
    }

    savingDownloadFreeSettings.value = true
    try {
        const payload = {
            paper: {
                is_enabled: downloadFreeSettings.paper.is_enabled,
                start_time: downloadFreeSettings.paper.start_time,
                end_time: downloadFreeSettings.paper.end_time
            },
            custom_paper: {
                is_enabled: downloadFreeSettings.custom_paper.is_enabled,
                start_time: downloadFreeSettings.custom_paper.start_time,
                end_time: downloadFreeSettings.custom_paper.end_time
            }
        }
        const res = await api.post('/api/admin/download-free-settings', payload)
        applyDownloadFreeSettings(res.data)
        ElMessage.success('下载免费设置已保存')
    } catch (error) {
        ElMessage.error(error?.response?.data?.error || '保存下载免费设置失败')
    } finally {
        savingDownloadFreeSettings.value = false
    }
}

// --- Utils ---
const formatTarget = (p) => {
    if (p.target_type === 'all') return '全站'
    if (p.target_type === 'category') return `分类: ${p.target_value}`
    if (p.target_type === 'paper') return `试卷ID: ${p.target_id}`
    return '未知'
}

const formatDate = (ts) => {
    if (!ts) return '-'
    return new Date(ts * 1000).toLocaleString()
}
</script>

<style scoped>
.admin-pricing-container {
    max-width: 1200px;
    margin: 0 auto;
}

.filter-bar,
.action-bar {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}

.tip-text {
    font-size: 13px;
    color: #909399;
    margin-left: 20px;
}

.info-text {
    color: #303133;
    font-weight: bold;
}

.price-text {
    font-size: 16px;
    color: #f56c6c;
    font-weight: bold;
}

.pagination-container {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
}

.action-bar-v {
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin-bottom: 25px;
    background: #f8f9fb;
    padding: 15px;
    border-radius: 8px;
}

.action-row {
    display: flex;
    align-items: center;
}

.defaults-info {
    display: flex;
    align-items: center;
    gap: 15px;
    font-size: 13px;
}

.defaults-info .label {
    color: #606266;
    font-weight: 500;
}

.tags-group {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
}

.download-free-panel {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.free-item-card {
    border: 1px solid #ebeef5;
}

.free-item-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.download-free-actions {
    display: flex;
    justify-content: flex-end;
}

.user-search-bar {
    margin-bottom: 20px;
}

.user-item {
    display: flex;
    justify-content: space-between;
    width: 100%;
}

.user-id {
    color: #909399;
    font-size: 12px;
}

.user-name {
    margin-left: 10px;
    font-weight: 500;
}

.form-helper {
    font-size: 12px;
    color: #909399;
    margin-top: 5px;
}
</style>
